// @flow
import { downloadRequestWithToken, fetchRequest } from './index';
import type {
  VehicleUtilizationFilter,
  VehicleFactUtilization
} from '../types/vehicleUtilization';

/**
 * Получить данные отчёта (GET /api/Report/vehicle-utilization)
 */
export const getVehicleUtilization = (
         params: VehicleUtilizationFilter
       ): Promise<VehicleFactUtilization[]> => {
         // fetchRequest.get сериализует ВТОРОЙ аргумент в query-string.
         // Axios-стиль { params } здесь не поддерживается и приводил к params=[object Object].
         return fetchRequest.get('/Report/vehicle-utilization', params);
       };

/**
 * Скачать Excel‑файл отчёта (GET /api/Report/vehicle-utilization/print)
 */
export const exportVehicleUtilization = async (
  params: VehicleUtilizationFilter
): Promise<void> => {
  const fileName = `VehicleUtilization_${new Date()
    .toISOString()
    .slice(0, 10)}.xlsx`;

  // downloadRequestWithToken корректно добавляет query params и скачивает blob.
  await downloadRequestWithToken(
    '/Report/vehicle-utilization/print',
    params,
    fileName,
  );
};

// Экспорт по умолчанию (опционально)
export default {
  getVehicleUtilization,
  exportVehicleUtilization
};
